module.exports = __webpack_public_path__ + "img/team-map-02.49f893d2.png";